<template>
  <div class="min-w-full">
    <div ref="chart"></div>
  </div>
</template>

<script>
import Highcharts from 'highcharts';
import { mapState } from 'vuex';

export default {
  name: 'Histogram',
  props: {
    title: {
      type: String,
      default: () => 'Histogram',
    },
  },
  data() {
    return {
      chart: '',
    };
  },
  computed: {
    ...mapState('base', [
      'loading',
      'bins',
    ]),
    chartColumns() {
      return this.bins.map(
        (bin) => `${Number(bin.minimumValue).toFixed(2)} -
        ${Number(bin.maximumValue).toFixed(2)}%`,
      );
    },
    chartValues() {
      return [{
        name: 'Number of Loans',
        data: this.bins.map((bin) => bin.frequency),
      }];
    },
  },
  methods: {
    generateChart() {
      const { chart } = this.$refs;
      const fontFamily = 'Inter var';
      const options = {
        credits: false,
        chart: {
          spacing: [0, 0, 0, 0],
          height: 300,
          type: 'column',
          spacingRight: 20,
          spacingTop: 20,
        },
        title: {
          floating: true,
          text: '',
        },
        xAxis: {
          title: {
            enabled: false,
            text: 'APR',
            style: {
              fontFamily,
              fontSize: '24px',
              fontWeight: 700,
            },
          },
          labels: {
            step: Math.floor(this.chartColumns.length / 2),
            align: 'center',
            style: {
              fontFamily,
              fontSize: '12px',
              fontWeight: 700,
            },
          },
          showFirstLabel: true,
          showLastLabel: true,
          categories: this.chartColumns,
        },
        yAxis: {
          title: {
            text: 'Loans',
            style: {
              fontFamily,
              fontSize: '16px',
              fontWeight: 700,
            },
          },
        },
        plotOptions: {
          column: {
            groupPadding: 0,
            pointPadding: 0.02,
            borderWidth: 0,
            borderRadius: 5,
            color: '#0e9f6e',
          },
          style: {
            paddingRight: '10px',
          },
        },
        tooltip: {
          style: {
            fontFamily,
            fontSize: '12px',
          },
        },
        legend: {
          enabled: false,
        },
        series: this.chartValues,
      };

      this.chart = Highcharts.chart(chart, options);
      if (this.loading) {
        this.chart.showLoading();
      }
    },
    updateChart() {
      this.chart.series[0].setData(this.bins.map((bin) => bin.frequency));
    },
    reRenderChart() {
      this.chart.destroy();
      setTimeout(() => {
        this.generateChart();
      }, 50);
    },
  },
  watch: {
    bins() {
      if (this.chart) {
        this.updateChart();
      } else {
        this.generateChart();
      }
    },
    loading(loading) {
      if (loading) {
        this.chart.showLoading();
      } else {
        this.chart.hideLoading();
      }
    },
  },
  mounted() {
    this.generateChart();
    window.addEventListener('orientationchange', this.reRenderChart);
  },
  beforeDestroy() {
    window.removeEventListener('orientationchange', this.reRenderChart);
  },
};
</script>
